import {ServiceDrivenIndexPage} from "../../Common/ServiceDrivenIndexPage";
import {service as SampleEventService} from "../../../Services/SampleEventService";

export const SampleEventIndexPage = ServiceDrivenIndexPage(SampleEventService)

